export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "back_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs"])},
        "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "id_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
        "first_name_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])},
        "last_name_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "email_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "region_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Région"])},
        "signed_up_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inscrit"])},
        "signed_up_yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
        "signed_up_no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])},
        "signup_link_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lien d'inscription"])},
        "stores_section_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points de vente"])},
        "store_id_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
        "store_name_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
        "store_status_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
      },
      "en": {
        "back_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
        "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "id_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
        "first_name_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First name"])},
        "last_name_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last name"])},
        "email_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "region_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Region"])},
        "signed_up_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Signed up"])},
        "signed_up_yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
        "signed_up_no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])},
        "signup_link_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Signup link"])},
        "stores_section_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points of sale"])},
        "store_id_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
        "store_name_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "store_status_column": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
      }
    }
  })
}
